import React, { useEffect } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";

const ConsultSpecialist = () => {
  return (
    <section className="consult-specialist-section section-space pt-0">
      <Container fluid className="showcase-container">
        <div>
          {/* <Row className="d-flex align-items-center">
            <Col md={{ span: 6, offset: 6 }}> */}
              <div className="inner-wrap text-left text-center text-lg-left text-sm-center text-md-center">
                {/* <span>Feel Free To Talk With Us</span> */}
                <h2 className="text-capitalize">Consult With A  {Je_welryspelling}  Specialist</h2>
                <p>
                  See the collections in person at either
                  of our  <br /> showrooms located in
                  San Jose, CA
                </p>
                <Link
                  className="btn outline-base-btn large"
                  to="/make-an-appointment"
                >
                Schedule An Appointment
                </Link>
              </div>
            {/* </Col>
          
          </Row> */}
        </div>
      </Container>
    </section>
  );
};

export default ConsultSpecialist;
